import React from 'react';
import { motion } from 'framer-motion';
import { Brain, GitBranch, ShieldAlert, HeartPulse, Users, Compass, Scale } from 'lucide-react';
export function CapabilityDomains() {
  const capabilities = [{
    icon: <Brain size={20} data-id="element-139" data-mp="311vw7wy7l2gg" />,
    title: 'Reasoning Quality',
    desc: 'Evaluate claims, weigh evidence, identify contradictions, and process complexity with greater clarity.',
    link: '#reasoning-quality'
  }, {
    icon: <GitBranch size={20} data-id="element-140" data-mp="3spo3pwv2i5bh" />,
    title: 'Consequential Thinking',
    desc: 'Understand tradeoffs, second-order effects, and long-range outcomes before decisions are made.',
    link: '#consequential-thinking'
  }, {
    icon: <ShieldAlert size={20} data-id="element-141" data-mp="3opnk7xt433xk" />,
    title: 'Manipulation Resistance',
    desc: 'Detect propaganda, emotional framing, rhetorical deception, ideological capture, and disinformation.',
    link: '#manipulation-resistance'
  }, {
    icon: <HeartPulse size={20} data-id="element-142" data-mp="2dcbgro19knbx" />,
    title: 'Emotional Regulation',
    desc: 'Improve stability under stress, reduce reactivity, and strengthen decision quality under pressure.',
    link: '#emotional-regulation'
  }, {
    icon: <Users size={20} data-id="element-143" data-mp="kch56jvihadw" />,
    title: 'Social Cooperation',
    desc: 'Navigate disagreement, handle conflict, and contribute constructively inside groups and institutions.',
    link: '#social-cooperation'
  }, {
    icon: <Compass size={20} data-id="element-144" data-mp="tcdnm3rb5d0i" />,
    title: 'Self-Direction and Execution',
    desc: 'Build discipline, follow-through, planning ability, and the capacity to turn intent into action.',
    link: '#self-direction'
  }, {
    icon: <Scale size={20} data-id="element-145" data-mp="135b7oeby7a18" />,
    title: 'Leadership Responsibility',
    desc: 'Strengthen the ability to manage complexity, absorb dissent, and act responsibly at scale.',
    link: '#leadership-responsibility',
    featured: true
  }];
  return <section className="py-20 lg:py-28 px-4 sm:px-6 lg:px-8 max-w-7xl mx-auto" data-id="element-146" data-mp="183crx2l41fea">
      <div className="mb-16" data-id="element-147" data-mp="1f61fmz599pgu">
        <span className="text-xs font-semibold text-teal uppercase tracking-[0.2em] mb-4 block" data-id="element-148" data-mp="1f6ud19ibr2mb">
          Core Capabilities
        </span>
        <h2 className="text-3xl md:text-4xl font-heading font-bold text-ink-dark" data-id="element-149" data-mp="1k29oxvwruog3">
          The foundations of judgment and readiness
        </h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-150" data-mp="1tv7ayc0z2vjg">
        {capabilities.map((cap, index) => <motion.a key={cap.title} href={cap.link} initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-50px'
      }} transition={{
        duration: 0.5,
        delay: index * 0.05
      }} className={`bg-surface-card p-8 rounded-lg border border-line shadow-sm hover:shadow-md hover:border-navy/30 transition-all group ${cap.featured ? 'md:col-span-2 lg:col-span-3 lg:w-2/3 mx-auto bg-surface-muted/50 border-navy/20' : ''}`} data-id="element-151" data-mp="1xy3qtuz4odjp" data-mpi={index}>
            <div className={`w-10 h-10 rounded-md flex items-center justify-center mb-6 ${cap.featured ? 'bg-navy text-white' : 'bg-surface-muted text-navy-light border border-line'}`} data-id="element-152" data-mp="2qwz3q8fczd8p">
              {cap.icon}
            </div>
            <h3 className="text-xl font-heading font-bold text-ink-dark mb-3 group-hover:text-navy transition-colors" data-id="element-153" data-mp="3en38wk873l1t">
              {cap.title}
            </h3>
            <p className="text-ink-muted leading-relaxed mb-3" data-id="element-154" data-mp="35ng5jsvwo564">{cap.desc}</p>
            <div className="flex items-center gap-1 text-navy text-sm font-medium opacity-0 group-hover:opacity-100 transition-opacity" data-id="element-155" data-mp="35pj6h7yljipm">
              Learn More
              <svg width="14" height="14" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" data-id="element-156" data-mp="1u9cfgxsfv16c">
                <path d="M6 12L10 8L6 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" data-id="element-157" data-mp="3d4l59fn4augn" />
              </svg>
            </div>
          </motion.a>)}
      </div>
    </section>;
}